import { Eyebrow, Reveal } from "./Reveal";

const STEPS = [
  ["Tell me about you", "A short form or a quick call. Household, budget, doctors, goals — nothing you'd rather keep to yourself."],
  ["I shop the options", "I compare plans and policies side by side and cut the jargon down to what actually matters to you."],
  ["You choose, I enroll", "Pick the fit. I handle the paperwork, applications and any subsidy documentation."],
  ["I stay in your corner", "Claims questions, renewals, life changes — you keep the same agent year after year."],
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="grain relative bg-[#071510] text-[#FAF8F5] py-24 lg:py-36 overflow-hidden">
    <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8">
      <Reveal>
        <Eyebrow light>02 — How it works</Eyebrow>
        <h2 className="font-serif-d text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight mt-5 max-w-3xl leading-[1.02]">Four calm steps from <em className="text-[#E5A855]">uncertain</em> to covered.</h2>
      </Reveal>
      <div className="mt-16 lg:mt-24 grid md:grid-cols-2 lg:grid-cols-4 border-t border-white/15">
        {STEPS.map(([t, d], i) => (
          <Reveal key={t} delay={i * 0.1} className="group border-b lg:border-b-0 md:[&:nth-child(odd)]:border-r lg:border-r border-white/15 lg:last:border-r-0 p-6 lg:p-8 pt-10">
            <div data-testid={`process-step-${i + 1}`}>
              <span className="font-serif-d text-7xl lg:text-8xl text-outline group-hover:text-[#E5A855] transition-colors duration-500">0{i + 1}</span>
              <h3 className="font-serif-d text-2xl lg:text-3xl mt-6">{t}</h3>
              <p className="mt-3 text-sm md:text-base text-[#F4F1EA]/75 leading-relaxed">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
